module.exports = __webpack_public_path__ + "img/fevend-presentation.db9f6e6c.png";